import SEO from '../../components/base/SEO';
import Breadcrumb from '../../components/feature/Breadcrumb';
import Header from './components/Header';
import Hero from './components/Hero';
import BasicSpecs from './components/BasicSpecs';
import Merits from './components/Merits';
import Demerits from './components/Demerits';
import PointGuide from './components/PointGuide';
import SuitableFor from './components/SuitableFor';
import HowToApply from './components/HowToApply';
import Reviews from './components/Reviews';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function RecruitPage() {
  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: '高還元率クレジットカード', path: '/highreturn' },
    { label: '高還元率カード詳細' }
  ];

  return (
    <>
      <SEO
        title="高還元率カード詳細 | 1.2%還元で年会費永年無料 | クレジットカード比較ナビ"
        description="業界最高水準の1.2%還元率を誇る高還元率カードの詳細情報。年会費永年無料で、通常利用でも1.2%の高還元。提携サービスでさらにお得にポイントが貯まります。"
        keywords="高還元率カード,1.2%還元,年会費無料,ポイント高還元,クレジットカード"
        canonical="https://creditcard-navi.com/recruit"
      />
      <Header />
      <main>
        <Breadcrumb items={breadcrumbItems} />
        <Hero />
        <BasicSpecs />
        <Merits />
        <Demerits />
        <PointGuide />
        <SuitableFor />
        <HowToApply />
        <Reviews />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
